module.exports = __webpack_public_path__ + "img/chicken.61a63c33.svg";